import qs from 'qs'
import APIClient from '../factories/APIClient'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Explore.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_EXPLORE_API_BASE_URL,
})

const clientApi = new APIClient({
  baseURL: process.env.REACT_APP_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'get /merchants': 200,
    // 'get /merchants*': 422,
    // 'get /stores/details': 200,
    // 'get /stores/*': 200,
    // 'get /stores': 200,
    // 'get /search': 200,
    // 'get /display/shop*': 200,
    // 'get /display/dine*': 422,
    // 'get /display/unwind*': 422,
    // 'get /display/featured?type=0*': 200,
    // 'get /display/featured?type=1*': 200,
    // 'get /display/featured?type=2*': 200,
    // 'get /participating-stores': 200
    // 'get /events/*/arcticles': 200,
    // 'get /popup-modals': 200,
  })
}

const appendPreferenceIds = ids => {
  let appendString = ''
  ids.forEach(id => {
    appendString += `&preferenceIds=${id}`
  })
  return appendString
}

export const getAllShopMerchants = ({
  limit = '',
  mallSlug = '',
  collectionType = 0,
  preferenceIds = [],
}) =>
  client({
    method: 'get',
    url: `/display/shop?mallSlugName=${encodeURIComponent(
      mallSlug,
    )}&limit=${encodeURIComponent(
      limit,
    )}&collectionType=${collectionType}${appendPreferenceIds(
      preferenceIds,
    )}&isFilterOutNoImage=true`,
    headers: {
      'Content-Type': 'application/pre.sticky.app.v2.0+json',
    },
  })

export const getAllDineMerchants = ({
  limit = '',
  mallSlug = '',
  collectionType = 0,
  preferenceIds = [],
}) =>
  client({
    method: 'get',
    url: `/display/dine?mallSlugName=${encodeURIComponent(
      mallSlug,
    )}&limit=${encodeURIComponent(
      limit,
    )}&collectionType=${collectionType}${appendPreferenceIds(
      preferenceIds,
    )}&isFilterOutNoImage=true`,
    headers: {
      'Content-Type': 'application/pre.sticky.app.v2.0+json',
    },
  })

export const getAllUnwindMerchants = ({
  limit = '',
  mallSlug = '',
  collectionType = 0,
  preferenceIds = [],
}) =>
  client({
    method: 'get',
    url: `/display/unwind?mallSlugName=${encodeURIComponent(
      mallSlug,
    )}&limit=${encodeURIComponent(
      limit,
    )}&collectionType=${collectionType}${appendPreferenceIds(
      preferenceIds,
    )}&isFilterOutNoImage=true`,
    headers: {
      // Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/pre.sticky.app.v2.0+json',
    },
  })

export const getAllPopularMerchants = () => {}

export const getMerchant = () => {}

export const getAllOrderNowMerchants = (
  mallSlugName,
  accessToken,
  limit = '',
) =>
  client({
    method: 'get',
    url: `/order-now?mallSlugName=${encodeURIComponent(
      mallSlugName,
    )}&limit=${encodeURIComponent(limit)}`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/pre.sticky.app.v2.0+json',
    },
  })

export const getAllMerchants = (accessToken, limit = '') =>
  client({
    method: 'get',
    url: `/merchants?limit=${encodeURIComponent(limit)}`,
    headers: {
      // Authorization: `Bearer ${accessToken}`,
    },
  })

export const getMerchantRelatedArticles = () => {}

export const getStore = id =>
  client({
    method: 'get',
    url: `/stores/${encodeURIComponent(id)}`,
  })

export const getIndoorMapStore = (externalId, mallSlugName) =>
  client({
    method: 'get',
    url: '/stores/details',
    params: {
      externalId,
      mallSlugName,
    },
  })

export const exploreSearch = (mallId, word, collectionType = 0) =>
  client({
    method: 'get',
    url: `/search?collectionType=${collectionType}`,
    params: {
      mallId,
      word,
    },
  })

export const getAmenity = id =>
  client({
    method: 'get',
    url: `/amenities/${encodeURIComponent(id)}`,
  })

export const getZingPartners = (accessToken, { limit, mallSlugName } = {}) => {
  const query = qs.stringify({
    limit,
    mallSlugName,
  })

  return client({
    method: 'get',
    url: `/zing-partners?${query}`,
    headers: {
      // Authorization: `Bearer ${accessToken}`,
    },
  })
}

export const getPopupModal = () =>
  client({
    method: 'get',
    url: '/popup-modals',
  })

export const getTransportationMalls = () =>
  client({
    method: 'get',
    url: '/transportations/malls',
  })

export const getMallRoutes = (accessToken, mallId) =>
  client({
    method: 'get',
    url: '/transportations/routes',
    params: {
      mallId: parseInt(mallId),
    },
  })

export const getLocationRoutes = locationId =>
  client({
    method: 'get',
    url: '/transportations/routes',
    params: {
      locationId: parseInt(locationId),
    },
  })

export const getLocations = () =>
  client({
    method: 'get',
    url: '/transportations/locations',
  })

export const getFeatureStatus = accessToken =>
  client({
    method: 'get',
    url: '/feature-status',
    headers: accessToken
      ? {
          Authorization: `Bearer ${accessToken}`,
        }
      : undefined,
  })

export const getMappedinKeys = () =>
  client({
    method: 'get',
    url: '/mapper/mapped-in',
    headers: {
      'client-secret': process.env.REACT_APP_MAPPEDIN_API_KEY,
    },
  })

export const getMallMerchants = (mallSlug, category = 'all') =>
  client({
    method: 'get',
    url: `/stores/list?mallSlug=${mallSlug}&category=${category}`,
  })

export const getSurveyAvailable = accessToken =>
  clientApi({
    method: 'get',
    url: `/notifications/survey/prompt`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

export const sendSurveyFeedback = (accessToken, data) =>
  clientApi({
    method: 'post',
    url: `/notifications/survey/maps`,
    data: data,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      platform: 2,
    },
  })

export const sendGuestSurveyFeedback = data =>
  clientApi({
    method: 'post',
    url: `/notifications/survey/maps/guest`,
    data: data,
    headers: {
      platform: 2,
    },
  })
